<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="pop-content-search">
        <el-form size="mini">
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="신고자">
                <el-input v-model="form.custNm" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="연락처">
                <el-input v-model="form.telNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="요청일시">
                <el-date-picker type="date" placeholder="요청일시" v-model="form.requestVisitDt" style="width: 100%;" readonly>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="접수일시">
                <el-date-picker type="date" placeholder="접수일시" v-model="form.callDt" style="width: 100%;" readonly>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="처리일시">
                <el-date-picker type="date" placeholder="처리일시" v-model="form.procDt" style="width: 100%;" readonly>
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="고객구분">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="25">
                      <el-select v-model="form.custType" disabled>
                        <el-option
                          v-for="item in custGbList"
                          :key="item.value"
                          :label="item.key"
                          :value="item.value">
                          </el-option>
                      </el-select>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="사이트명">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm1" readonly></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm2" readonly></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm3" readonly></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="주소">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="3">
                      <el-input type="text" v-model="form.addr1" readonly></el-input>
                    </el-col>
                    <el-col :span="3">
                      <el-input type="text" v-model="form.addr2" readonly></el-input>
                    </el-col>
                    <el-col :span="9">
                      <el-input type="text" v-model="form.addr3" readonly></el-input>
                    </el-col>
                    <el-col :span="9">
                      <el-input type="text" v-model="form.addr4" readonly></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="고객명">
                <el-input v-model="form.custNm" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="전화번호">
                <el-input v-model="form.telNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="핸드폰">
                <el-input v-model="form.hpNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="MA구분">
                <el-input v-model="form.maYn" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="유/무상">
                <el-input v-model="form.payYn" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="grid-wrap">
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
        <component ref="cmpReceptionModal" v-bind:is="viewer"  @loadTab="loadTab"/>
        <!--  -->
      </div>
    </div>
  </layout>
</template>

<script>
/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';

/**
 * * Tab 구분 컴포넌트
 */
import tabs from '@/components/AS/Tabs/index.vue';
import procsHist from './ProcsHst';
import recptHst from './RecptHst';
import rstHst from './RstHst';

import rcpt from './index';

export default {
    mixins: [rcpt],
    props: {
        data: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {Layout, tabs, procsHist, recptHst, rstHst},
    data() {
        return {
            title: '접수/처리상세내역',
            viewer: 'procsHist',
            active: true,
            tab:[
                {tabId: 'recptHst', tabName:'접수내역', tabCss:"btn btn-outline-primary", tabNo:'0'},/** 'btn btn-nonActive'버튼 비활성화 class */
                {tabId: 'procsHist', tabName:'처리내역', tabCss:"btn btn-primary", tabNo:'1'},
                {tabId: 'rstHst', tabName:'정산내역', tabCss:"btn btn-outline-primary", tabNo:'2'},
            ],
            custGbList: [{key: '1', value: '일반'}, {key: '2', value: 'VIP'}],
            form : {
              custCd: '01',
            },
            receptionParam: {}
        }
    },
    created() {
        
        this.$bus.$on('input', (val) => {
            // console.log('-> input bus on ', val);
        });
    },
    mounted() {
        //pop slots modal move
        $(".animation-content").addClass('pop_min2');
        $(".animation-content").draggable({'cancel':'.modal-card-body'});
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '4');

        this.getCustTypeCombo()
        console.log('mounted aaa==', this.data.popHeadInfo)
        this.goOpen('INIT', 0) 
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        changeTab(params) {
            this.viewer = params.tabId;
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        getCustTypeCombo() {
            // 고객구분
            this.$http.get(`/api/codeMng/combo`, {params: {parentId: 10}})
                .then(response => {
                    this.custGbList = response.data;
                });
        },
        goOpen(callFlag, param) {
            this.$store.commit('loading')
            const vAsDetailId = param.asDetailId || 0
            const vAsProcessId = param.asProcessId || 0
            
            this.$http.post(_url("/api/asMng/popup/asRead"), {
                companyId: 'CENTERLINK', //this.$store.state.loginInfo.compCd,
                asId: this.form.asId,
                asDetailId: callFlag === 'INIT' ? 0 : vAsDetailId,
                asProcessId: callFlag === 'INIT' ? 0 : vAsProcessId,
                custId: this.form.custId,
                sortType: this.form.sortType || '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
 
            }).then(response => {
                console.log('ReceptionModal response.data :' , response.data)
                
                if(response.data.callAsDetail){
                  response.data.callAsDetail = response.data.callAsDetail.map(x => {
                    x.guaranteeEndDt = x.guaranteeEndDt ? x.guaranteeEndDt.substring(0,10) : ''
                    return x
                  })
                }
                console.log('ReceptionModal response.data2 :')
                if(response.data.callAsFailureCause){
                  response.data.callAsFailureCause = response.data.callAsFailureCause.map(x => {
                    const arr1 = x.asFailureCauseCatFullNm.split('>')
                    if(arr1.length >= 1){
                      x.asFailureCauseCat1 = arr1[1]
                    }
                    
                    return x
                  })
                }
                console.log('ReceptionModal response.data3 :')
                if(response.data.callAsRepair){
                  response.data.callAsRepair = response.data.callAsRepair.map(x => {
                    if(x.asRepairCatFullNm){
                      const arr1 = x.asRepairCatFullNm.split('>')
                      if(arr1.length > 1){
                        x.asRepairCat1 = arr1[1] || ''
                      }
                      
                      if(arr1.length > 2){
                        x.asRepairCat2 = arr1[2] || ''
                      }
                      
                      if(arr1.length > 3){
                        x.asRepairCat3 = arr1[3] || ''
                      }
                    }

                    return x
                  })
                }
                console.log('ReceptionModal response.data4 :')
                
                 
                this.receptionParam = response.data
                this.receptionParam.asId = this.data.asId
                this.receptionParam.custId = this.form.custId
                this.receptionParam.sortType = this.form.sortType

                this.form.asId = this.data.asId

                if(response.data.callAsMstSelList){
                  const asForm = response.data.callAsMstSelList[0]
                  this.form.custNm = asForm.custNm
                  this.form.telNo = asForm.telNo
                  this.form.requestVisitDt = asForm.requestVisitDt
                  this.form.callDt = asForm.callDt
                  this.form.procDt = asForm.procDt
                }
                
                if(response.data.callAsProcessSel1List){
                  this.receptionParam.asProcessId = response.data.callAsProcessSel1List[0].asProcessId
                
                  //this.$refs.cmpReceptionModal.data = response.data.callAsProcessSel1List
                  //console.log('this.$refs.cmpReceptionModal: ', this.$refs.cmpReceptionModal)
                 // this.$refs.cmpReceptionModal.changeProcModel(this.receptionParam)
                  
                  if(callFlag === 'INIT'){
                    // 초기로딩시 디폴트로 처리내역이 활성화
                    this.subLoadTab( {"tabNm":"2", "index": 0} )
                  } else {
                    this.subLoadTab( param )
                  }
                  
                }


            }).finally(() => {
                this.$store.commit('finish')
            });
            
        },
        subLoadTab(param) {
          console.log('loadTab =====start', param, this.receptionParam, this.$refs.cmpReceptionModal)
          if(this.receptionParam.asId) {
            const index = param.index || 0
            if(param.tabNm === "1"){  /** 접수내역 */
              this.$refs.cmpReceptionModal.data = this.receptionParam.callAsDetail.map(x=>{
                x.recptTp = (x.subAsClassNm==='유상수리') ? '01' : '02'; // 접수유형/세부유형
                
                return x;
              });
              this.$refs.cmpReceptionModal.changeRecpHstInfo(this.receptionParam, index);
            
            } else if(param.tabNm === "2"){
              this.$refs.cmpReceptionModal.data = this.receptionParam.callAsProcessSel1List
              this.$refs.cmpReceptionModal.changeProcsHstInfo(this.receptionParam, index)
            } else if(param.tabNm === "3"){
              this.$refs.cmpReceptionModal.data = this.receptionParam.callAsProcessSel1List
            }
          }              
        },
        loadTab(param) {
          // 서브탭인 접수내역, 처리내역탭에서 asDetailId, asProcessId을 클릭한 경우 재로딩
          this.goOpen('RELOAD', param)
        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>